enum Path {
  Home = '/',
  Users = '/users',
  User = '/users/:id',
  Login = '/login',
  Logout = '/logout',
  ForgotPassword = '/forgot-password',
  PendingTransactions = '/pending-transactions',
  Reports = '/reports',
  Profile = '/profile',
  Settings = '/settings',
  Help = '/help',
  PortalUsers = '/users',
  Offers = '/offers',
  Merchants = '/merchants',
  Locations = '/locations',
  Audits = '/audits',
  Segment = '/segments',
  Experiments = '/experiments',
}

export default Path;
